import { type Card, type Rank, type Suit, SUITS } from '../trick/cards.js';

// The deck is shared with the other trick-taking games (../trick/cards.ts); these are Bridge's names
// for it, so nothing that imports from the bridge module changes.
export type BridgeSuit = Suit;
export type BridgeRank = Rank;
export type BridgeCard = Card;
export const BRIDGE_SUITS: readonly BridgeSuit[] = SUITS;
export { cardId, fullDeck, isJoker, JOKER_RANK, jokerCard, jokerColour, parseCard, sameCard, sortHand, suitCounts } from '../trick/cards.js';
export type { JokerColour } from '../trick/cards.js';

/** High-card points: Ace 4, King 3, Queen 2, Jack 1. The whole deck holds 40. */
export function highCardPoints(cards: readonly BridgeCard[]): number {
  let total = 0;
  for (const c of cards) if (c.rank >= 11) total += c.rank - 10; // J=1, Q=2, K=3, A=4
  return total;
}
